import { render, staticRenderFns } from "./SimpleColorPicker.vue?vue&type=template&id=18e8e91a&scoped=true&"
import script from "./SimpleColorPicker.vue?vue&type=script&lang=ts&"
export * from "./SimpleColorPicker.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleColorPicker.vue?vue&type=style&index=0&id=18e8e91a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e8e91a",
  null
  
)

export default component.exports